/** Bump when optional cookie categories or copy change — prompts a fresh choice. */
export const COOKIE_CONSENT_VERSION = "1.0";

export const COOKIE_CONSENT_STORAGE_KEY = "jobuwin-cookie-consent";

export function hasPostHogTrackingConfigured() {
  return Boolean(String(process.env.REACT_APP_POSTHOG_KEY || "").trim());
}

export function hasTawkTrackingConfigured() {
  const propertyId = String(process.env.REACT_APP_TAWK_PROPERTY_ID || "").trim();
  const widgetId = String(process.env.REACT_APP_TAWK_WIDGET_ID || "").trim();
  return Boolean(propertyId && widgetId);
}

/** True when at least one optional (non-essential) tracker may load. */
export function hasOptionalTrackingServices() {
  return hasPostHogTrackingConfigured() || hasTawkTrackingConfigured();
}

function normalizeConsentRecord(raw) {
  if (!raw || typeof raw !== "object") return null;
  if (raw.version !== COOKIE_CONSENT_VERSION) return null;
  return {
    version: COOKIE_CONSENT_VERSION,
    analytics: Boolean(raw.analytics),
    support: Boolean(raw.support),
    decidedAt: String(raw.decidedAt || "").trim() || new Date().toISOString(),
  };
}

export function readStoredCookieConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;
    return normalizeConsentRecord(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function writeStoredCookieConsent({ analytics, support }) {
  const record = normalizeConsentRecord({
    version: COOKIE_CONSENT_VERSION,
    analytics: Boolean(analytics),
    support: Boolean(support),
    decidedAt: new Date().toISOString(),
  });
  if (typeof window !== "undefined") {
    window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(record));
  }
  return record;
}

export function clearStoredCookieConsent() {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(COOKIE_CONSENT_STORAGE_KEY);
  }
}

export function hasCookieConsentDecision() {
  return Boolean(readStoredCookieConsent());
}

export function hasAnalyticsConsent() {
  if (!hasPostHogTrackingConfigured()) return false;
  const consent = readStoredCookieConsent();
  return Boolean(consent?.analytics);
}

export function hasSupportConsent() {
  if (!hasTawkTrackingConfigured()) return false;
  const consent = readStoredCookieConsent();
  return Boolean(consent?.support);
}
